import { KNOCK_WORKFLOWS } from '../../../knock-workflows'
export const DATA_FIRESTORE_V01_KNOCK_WORKFLOWS = {
  NAME: 'v01_knock_workflows',
  FIELDS: {
    [KNOCK_WORKFLOWS.EVENT_OPEN_REGISTER_24]: {
      KEY: 'registrationsOpenIn24Hours',
      VALUES: {
        DEFAULT: null,
      },
    },
    [KNOCK_WORKFLOWS.EVENT_OPEN_REGISTER_1]: {
      KEY: 'registrationsOpenIn1Hour',
      VALUES: {
        DEFAULT: null,
      },
    },
    [KNOCK_WORKFLOWS.EVENT_OPEN_REGISTER_NOW]: {
      KEY: 'registrationsNowOpen',
      VALUES: {
        DEFAULT: null,
      },
    },
    [KNOCK_WORKFLOWS.EVENT_CLOSE_REGISTER_24]: {
      KEY: 'registrationsCloseIn24Hours',
      VALUES: {
        DEFAULT: null,
      },
    },
    [KNOCK_WORKFLOWS.EVENT_CLOSE_REGISTER_1]: {
      KEY: 'registrationsCloseIn1Hour',
      VALUES: {
        DEFAULT: null,
      },
    },
  },
}
